export function formatNumber(value: number, decimals: number = 0): string {
	if (!isFinite(value) || isNaN(value)) return "0";
	return value.toLocaleString("pt-BR", {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
}

const compactFormatter = new Intl.NumberFormat("pt-BR", {
	notation: "compact",
	compactDisplay: "short",
});

export function formatCompactNumber(value: number): string {
	if (!isFinite(value) || isNaN(value)) return "0";

	let roundedValue = value;
	if (value >= 1000000) {
		roundedValue = Math.floor(value / 100000) * 100000;
	} else if (value >= 1000) {
		roundedValue = Math.floor(value / 1000) * 1000;
	}

	return compactFormatter.format(roundedValue);
}

export function formatNumberConditional(value: number): string {
	if (value > 999999) {
		return formatCompactNumber(value);
	}
	return formatNumber(value);
}
